/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/scope */
import React, { useEffect, useState } from "react";
const ER1Update = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [formData, setFormData] = useState({
        ParametersId: Number(props.parametersId),
        EmploymentId: Number(props.employmentId),

         NIC2008at5digitlevel1 :0,
         Addressed2 :0,
         Responded3 :0,
         Total4 :0,
         Women5 :0,
         Total6 :0,
         Women7 :0,
         Total8 :0,
         Women9 :0,
         EstimatedEmploymentinDefaultingEstablishment10 :0,
         Remarks11 :0

    });
   
    const getdata = async () => {
        const sendData = {
            Er1detailsId: Number(props.er1detailsId),
        }
       // //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/ER/GetER1Details', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    const maindata = data[0]
                     ////console.log(maindata)
                    setFormData({
                        NIC2008at5digitlevel1: maindata.niC2008at5digitlevel1,
                        Addressed2: maindata.addressed2,
                        Responded3: maindata.responded3,
                        Total4: maindata.total4,
                        Women5: maindata.women5,
                        Total6: maindata.total6,
                        Women7: maindata.women7,
                        Total8: maindata.total8,
                        Women9: maindata.women9,
                        EstimatedEmploymentinDefaultingEstablishment10: maindata.estimatedEmploymentinDefaultingEstablishment10,
                        Remarks11: maindata.remarks11,
                        Er1detailsId: Number(props.er1detailsId),
                    });
                    setload(false)
                })


    };
    const onInputChange = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
       //  //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/ER/UpdateER1Details', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    ////console.log(maindata)
                    setFormData({
                        NIC2008at5digitlevel1: maindata.niC2008at5digitlevel1,
                        Addressed2: maindata.addressed2,
                        Responded3: maindata.responded3,
                        Total4: maindata.total4,
                        Women5: maindata.women5,
                        Total6: maindata.total6,
                        Women7: maindata.women7,
                        Total8: maindata.total8,
                        Women9: maindata.women9,
                        EstimatedEmploymentinDefaultingEstablishment10: maindata.estimatedEmploymentinDefaultingEstablishment10,
                        Remarks11: maindata.remarks11,
                        Er1detailsId: Number(props.er1detailsId),
                    });
                    setload(false)
                })
      
    };


    useEffect(() => {
        getdata()
    }, [])

    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };


    return (
          load ? null: <tr scope="row"  >


                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ? <input
                        type="number"
                        id="NIC2008at5digitlevel1"
                        className="form-control"
                        name="NIC2008at5digitlevel1"
                        maxLength="9"
                        min="0"
                        onKeyPress={inputHandler}
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value === 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value === '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.NIC2008at5digitlevel1}
                    /> : formData.NIC2008at5digitlevel1}


                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ? <input
                        type="number"
                        id="Addressed2"
                        className="form-control"
                        name="Addressed2"
                        maxLength="7"
                        min="0"
                        onKeyPress={inputHandler}
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value === 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value === '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Addressed2}
                    /> : formData.Addressed2}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ?
                        <input
                            type="number"
                            min="0"
                            id="Responded3"
                            className="form-control"
                            name="Responded3"
                            maxLength="7"
                            onKeyPress={inputHandler}
                            style={{ textAlign: 'center' }} onFocus={(e) => e.target.value === 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value === '' ? e.target.value = 0 : e.target.value}
                            onChange={(e) => onInputChange(e)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            defaultValue={formData.Responded3}
                        /> : formData.Responded3}


                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Total4"
                        className="form-control"
                        name="Total4"
                        maxLength="7"
                        onKeyPress={inputHandler}
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value === 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value === '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Total4}
                    /> : formData.Total4}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Women5"
                        className="form-control"
                        name="Women5"
                        maxLength="7"
                        onKeyPress={inputHandler}
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value === 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value === '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Women5}
                    /> : formData.Women5}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Total6"
                        className="form-control"
                        name="Total6"
                        maxLength="7"
                        onKeyPress={inputHandler}
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value === 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value === '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Total6}
                    /> : formData.Total6}

                </td>

                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Women7"
                        className="form-control"
                        name="Women7"
                        maxLength="7"
                        onKeyPress={inputHandler}
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value === 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value === '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Women7}
                    /> : formData.Women7}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Total8"
                        className="form-control"
                        name="Total8"
                        maxLength="7"
                        onKeyPress={inputHandler}
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value === 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value === '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Total8}
                    /> : formData.Total8}

                </td>



                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ?
                        <input
                            type="number"
                            min="0"
                            id="Women9"
                            className="form-control"
                            name="Women9"
                            maxLength="7"
                            onKeyPress={inputHandler}
                            style={{ textAlign: 'center' }} onFocus={(e) => e.target.value === 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value === '' ? e.target.value = 0 : e.target.value}
                            onChange={(e) => onInputChange(e)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            defaultValue={formData.Women9}
                        /> : formData.Women9}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ?
                        <input
                            type="number"
                            min="0"
                            id="EstimatedEmploymentinDefaultingEstablishment10"
                            className="form-control"
                            name="EstimatedEmploymentinDefaultingEstablishment10"
                            maxLength="7"
                            onKeyPress={inputHandler}
                            style={{ textAlign: 'center' }} onFocus={(e) => e.target.value === 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value === '' ? e.target.value = 0 : e.target.value}
                            onChange={(e) => onInputChange(e)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            defaultValue={formData.EstimatedEmploymentinDefaultingEstablishment10}
                        /> : formData.EstimatedEmploymentinDefaultingEstablishment10}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ?
                        <input
                            type="number"
                            min="0"
                            id="Remarks11"
                            className="form-control"
                            name="Remarks11"
                            maxLength="7"
                            onKeyPress={inputHandler}
                            style={{ textAlign: 'center' }} onFocus={(e) => e.target.value === 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value === '' ? e.target.value = 0 : e.target.value}
                            onChange={(e) => onInputChange(e)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            defaultValue={formData.Remarks11}
                        /> : formData.Remarks11}

                </td>

            </tr>
        
    );
};

export default ER1Update;
